import * as SalesforceRecordActions from '../actions/salesforceRecords';
import { reducer } from './reducerUtils';

const initialState = {
  isSalesforceRecordFormOpen: false,
  salesforceRecordObjectApiName: '',
  cachedObjectFieldSets: {},
  salesforceRecordRedirectLink: '',
  salesforceRecordTooltipContent: '',
};

export default reducer({
  [SalesforceRecordActions.IS_SALESFORCE_RECORD_FORM_OPEN]: (state, action) => ({
    ...state,
    isSalesforceRecordFormOpen: action.payload,
  }),
  [SalesforceRecordActions.SET_SALESFORCE_RECORD_OBJECT_API_NAME]: (state, action) => ({
    ...state,
    salesforceRecordObjectApiName: action.apiName,
  }),
  [SalesforceRecordActions.SET_CACHED_OBJECTS]: (state, action) => ({
    ...state,
    cachedObjectFieldSets: action.objects,
  }),
  [SalesforceRecordActions.SET_SALESFORCE_RECORD_REDIRECT_LINK]: (state, action) => ({
    ...state,
    salesforceRecordRedirectLink: action.redirectLink,
  }),
  [SalesforceRecordActions.SET_SALESFORCE_RECORD_TOOLTIP_CONTENT]: (state, action) => ({
    ...state,
    salesforceRecordTooltipContent: action.tooltipContent,
  }),
}, initialState);
